export const DataOnBoardingRouteDef = [ 
    {
        path: 'upload_file',
        component: 'UploadCSVComponent',
        data: {
            selector: 'app-upload-csv',
        }
    },
    {
        path: 'gct_master',
        component: 'GctMasterViewComponent',
        data: {
            selector: 'app-gct-master-view',
        }
    },
    {
        path: 'bulk_upload_checklist',
        component: 'BulkUploadChecklistComponent',
        data: {
            selector: 'app-bulk-upload-checklist',
        }
    },
    {
        path: 'master_upload',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'master_upload',
            input:'master_upload',
            action: 'LIST'
        }
    },
    {
        path: 'master_upload_system',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'master_upload_system',
            input:'master_upload_system',
            action: 'LIST',
            facilitySelection:false
        }
    },
    {
        path: 'master_upload_account',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'master_upload_account',
            input:'master_upload_account',
            action: 'LIST',
            facilitySelection:false
        }
    },
    {
        path: 'sales_worklist',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'sales_worklist',
            input:'sales_worklist',
            action: 'LIST'
        }
    },
    {
        path: 'upload_data',
        component: 'MasterUploadDataComponent',
        data: {
            selector: 'app-master-upload-data',
        }
    },
    {
        path: 'master_upload_template',
        component: 'MasterUploadTemplateComponent',
        data: {
            selector: 'app-master-upload-template',
            action:'ADD'
        }
    },
    {
        path: 'master_upload_template/:id/view',
        component: 'MasterUploadTemplateComponent',
        data: {
            selector: 'app-master-upload-template',
            action:'VIEW'
        }
    },
    {
        path: 'master_upload_template/:id/update_role',
        component: 'TemplateRoleUpdateComponent',
        data: {
            selector: 'app-template-role-update',
            action:'MODIFY'
        }
    },
    {
        path: 'master_upload_template/:id/update_form_template',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'template_update_form',
            action: 'MODIFY',
        }
    },
    {
        path: 'master_upload_template/:id/view_role',
        component: 'TemplateRoleUpdateComponent',
        data: {
            selector: 'app-template-role-update',
            action:'VIEW'
        }
    },
    {
        path: 'master_upload_template/:id/define_price',
        component: 'OnboardingPriceDefinitionComponent',
        data: {
            selector: 'app-onboarding-price-definition'
        }
    },
    {
        path: 'master_upload_template/calculate_price',
        component: 'OnboardingPriceCalculatorComponent',
        data: {
            selector: 'app-onboarding-price-calculator'
        }
    },
    {
        path: 'master_upload_template/:id/price_view',
        component: 'OnboardingPriceViewComponent',
        data: {
            selector: 'app-onboarding-price-view'
        }
    },
    {
        path: 'master_upload_template/:id/modify',
        component: 'MasterUploadTemplateComponent',
        data: {
            selector: 'app-master-upload-template',
            action:'MODIFY'
        }
    },
    {
        path: 'master_upload_template/:id/copy',
        component: 'MasterUploadTemplateComponent',
        data: {
            selector: 'app-master-upload-template',
            action:'COPY'
        }
    },
    {
        path: 'mis_master_sample',
        component: 'SampleMisComponent',
        data: {
            selector: 'app-sample-mis',
        }
    },
    {
        path: 'onboarding_format',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'onboarding_format',
            input:'onboarding_format'
        }
    },
    {
        path: 'system_integration',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'system_integration',
            input:'system_integration',
            action: 'FORM_GRID'
        }
    },
    {
        path: 'system_integration/:id/view',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource:'system_integration',
            input:'system_integration',
            action: 'VIEW'
        }
    },
    {
        path: 'machine_integration',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'machine_integration',
            input:'machine_integration',
            action: 'FORM_GRID'
        }
    },
    {
        path: 'machine_integration/:id/view',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource:'machine_integration',
            input:'machine_integration',
            action: 'VIEW'
        }
    },
    {
        path: 'print_state_management',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'print_state_management',
            input:'print_state_management',
            action: 'LIST'
        }
    },
    {
        path: 'print_state_management/:id/view',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource:'print_state_management',
            input:'print_state_management',
            action: 'VIEW'
        }
    },
    {
        path: 'print_state_management/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'print_state_management',
            input:'print_state_management',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'mis_state_management',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'mis_state_management',
            input:'mis_state_management',
            action: 'LIST'
        }
    },
    {
        path: 'mis_state_management/:id/view',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource:'mis_state_management',
            input:'mis_state_management',
            action: 'VIEW'
        }
    },
    {
        path: 'mis_state_management/:id/modify',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource: 'mis_state_management',
            id: 'id',
            action: 'MODIFY',
            facilitySelection:false
        }
    },
    {
        path: 'emr_state_management',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'emr_state_management',
            input:'emr_state_management',
            action: 'LIST'
        }
    },
    {
        path: 'emr_state_management/:id/view',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource:'emr_state_management',
            input:'emr_state_management',
            action: 'VIEW'
        }
    },
    {
        path: 'emr_state_management/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'emr_state_management',
            input:'emr_state_management',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'workflow_state_management',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'workflow_state_management',
            input:'workflow_state_management',
            action: 'LIST'
        }
    },
    {
        path: 'workflow_state_management/:id/view',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource:'workflow_state_management',
            input:'workflow_state_management',
            action: 'VIEW'
        }
    },
    {
        path: 'workflow_state_management/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'workflow_state_management',
            input:'workflow_state_management',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'training_scheduler',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'training_scheduler',
            input:'training_scheduler',
            action: 'FORM_GRID'
        }
    },
    {
        path: 'training_scheduler/:id/view',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource:'training_scheduler',
            input:'training_scheduler',
            action: 'VIEW'
        }
    },
    {
        path: 'onboarding_format_for_sales',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'onboarding_format_for_sales',
            input:'onboarding_format_for_sales'
        }
    },
    {
        path: 'user_feature_request/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'feature_request',
            input:'feature_request',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'user_training_scheduler/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'training_scheduler',
            input:'training_scheduler',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'user_desk_master/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'desk_state_management',
            input:'desk_state_management',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'user_onboarding_event_template/view',
        component: 'ViewEventDetailsComponent',
        data: {
            selector: 'app-view-event-details',
            resource:'onboarding_event_template',
            input:'onboarding_event_template'
        }
    },
    {
        path: 'user_project_plan/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'Project_plan',
            input:'Project_plan',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'user_machine_integration/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'machine_integration',
            input:'machine_integration',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'user_system_integration/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'system_integration',
            input:'system_integration',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'user_kx_resource_mapping/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'kx_resource_mapping',
            input:'kx_resource_mapping',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'user_customer_resource_mapping/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'customer_resource_mapping',
            input:'customer_resource_mapping',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'user_credential/add',
        component: 'OnboardingComponent',
        data: {
            selector: 'app-onboarding',
            resource:'master_credentials',
            input:'master_credentials',
            action:'ADD',
            facilitySelection:false
        }
    },
    {
        path: 'system_checklist',
        component: 'BulkUploadChecklistComponent',
        data: {
            selector: 'app-bulk-upload-checklist',
            input:'checklist',
            scope:'system'
        }
    },
    {
        path: ':foreign_id/details',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'oltp_to_mis_v2',
            action: 'LIST',
            foreign_id: 'oltp_id'
        }
    },
    {
        path: 'view_hie_documents',
        component: 'HieDocumentsViewerComponent',
        data: {
            selector: 'app-hie-documents-viewer',
            resource: 'view_hie_documents',
            action: 'IMAGE_VIEWER',
        }
    },
    {
        path: 'bulk_master_upload',
        component: 'HospitalOnboardingComponent',
        data: {
            selector: 'app-hospital-onboarding',
        }
    },
    {
        path: 'faq',
        component: 'HospitalFaqComponent',
        data: {
            selector: 'app-hospital-faq',
        }
    },
    {
        path: 'help',
        component: 'HospitalHelpComponent',
        data: {
            selector: 'app-hospital-help',
        }
    },
    {
        path: 'account',
        component: 'HospitalAccountComponent',
        data: {
            selector: 'app-hospital-account',
        }
    },
    {
        path: 'training',
        component: 'KnowledgeLibraryComponent',
        data: {
            selector: 'app-knowledge-library',
        }
    },
    {
        path: 'training/:id/video',
        component: 'KnowledgeLibraryVideoComponent',
        data: {
            selector: 'app-knowledge-library-video',
        }
    },
    {
        path: 'dashboard',
        component: 'HospitalDashboardComponent',
        data: {
            selector: 'app-hospital-dashboard',
        }
    },
    {
        path: 'facility-dashboard',
        component: 'HospitalFacilityDashboardComponent',
        data: {
            selector: 'app-hospital-facility-dashboard',
        }
    },
    {
        path: 'onboarding-training',
        component: 'HospitalOnboardComponent',
        data: {
            selector: 'app-hospital-onboard',
        }
    }
] 